import Nav from "../components/Nav";
import Footer from "../components/Footer";

const LayoutDefault = ({ children }) => {
  return (
    <div className="layout-default">
      <Nav />
      <main>{children}</main>
      <Footer />
    </div>
  );
};

export default LayoutDefault;
